import { render, staticRenderFns } from "./notificationReport.vue?vue&type=template&id=616a9790&scoped=true&"
import script from "./notificationReport.vue?vue&type=script&lang=js&"
export * from "./notificationReport.vue?vue&type=script&lang=js&"
import style0 from "./notificationReport.vue?vue&type=style&index=0&id=616a9790&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616a9790",
  null
  
)

export default component.exports